// ─── ICON REGISTRIES & CATEGORY DEFAULTS ──────────────────────────────────────
// Icon component maps + category/picker data extracted from App.jsx. These BOTH
// import blocks are reproduced VERBATIM from App.jsx so that every bare/aliased
// identifier in the maps resolves to the exact same component it did inline
// (e.g. bare `Cloud` = lucide's Cloud, bare `Anchor` = Phosphor's Anchor — the
// two packages are deliberately imported without name collisions). Do not trim.

import {
  Sparkle, PaintBrush, Wind as PhWind, BookOpenText, Barbell, Headphones as PhHeadphones,
  Users as PhUsers, Coins as PhCoins, AppleLogo as PhApple, Laptop as PhLaptop,
  House, Tree, Brain as PhBrain, Heart as PhHeart,
  Leaf as PhLeaf, NotePencil, Lightning,
  MusicNote, Basketball, Coffee as PhCoffee, Pill as PhPill,
  Moon as PhMoon, SunHorizon, GraduationCap as PhGrad, Microscope as PhMicroscope,
  Star as PhStar, Flower, ShootingStar, Drop,
  BowlFood, Bed, Shower, Bicycle, PersonSimpleRun,
  BookBookmark, PencilLine, Guitar, Palette as PhPalette2,
  Dog as PhDog, Cat as PhCat, Baby as PhBaby,
  Smiley, SmileyMeh, SmileySad,
  Sun, CloudSun, Snowflake as PhSnowflake,
  Confetti, Gift as PhGift, Trophy as PhTrophy,
  FirstAidKit, HeartStraight,
  PersonSimpleBike, PersonSimpleSwim, PersonSimpleHike, PersonSimpleSki,
  PersonSimpleWalk, PersonSimpleTaiChi,
  SoccerBall, Football, TennisBall as TennisBall2, Volleyball,
  SwimmingPool, SneakerMove,
  ForkKnife, CookingPot, Orange, Carrot, Bread,
  Stethoscope, Eye, Tooth,
  Backpack, Tent, Mountains, Island,
  Airplane, Car as PhCar, Bus as PhBus,
  Alarm, HourglassHigh, CalendarCheck as PhCalCheck,
  Flag as PhFlag, CheckCircle as PhCheckCircle,
  FireSimple, Fire as PhFire, ArrowsClockwise as PhArrowsClockwise,
  Wallet, PiggyBank, ChartLine as PhChartLine, Briefcase as PhBriefcase,
  HandsPraying, Peace, YinYang, Anchor,
  Camera as PhCamera, VideoCamera, FilmStrip, GameController,
  Code as PhCode, Terminal as PhTerminal, Robot as PhRobot,
  ChatTeardrop, Phone as PhPhone, Envelope as PhEnvelope,
  Scissors as PhScissors,
  Plant, TreeEvergreen,
  IceCream, Cookie, BeerStein, Wine as PhWine,
  Bathtub, ToiletPaper, Broom, Hammer as PhHammer,
  SmileyNervous, SmileyWink, SmileyAngry,
  Timer as PhTimer,
  Acorn, AirplaneLanding, AirplaneTakeoff, Aperture, Armchair,
  Atom, Avocado, Balloon, Bandaids, Bank,
  Baseball, Boat, Bone, BowlSteam, BoxingGlove,
  Broadcast, Bug, BugBeetle, Butterfly,
  Cactus, Cake, Calculator, Cards, CassetteTape,
  CastleTurret, Certificate, ChalkboardTeacher, Champagne, ChartBar,
  ChartPie, ChatCircle, ChatDots, Chats, CirclesThree,
  ClipboardText, Cloud as PhCloud, CloudLightning, CloudMoon, CloudRain,
  CloudSnow, Compass, Couch, CreditCard, Crosshair,
  Crown, CurrencyDollar, Desktop, Diamond, DiceFive,
  Dna, Door, Egg, Eraser, Exam,
  EyeSlash, Fish as PhFish, FishSimple, Flask, FlowArrow,
  FrameCorners, Gavel, Globe, Grains, GrainsSlash,
  Hamburger, HandSoap, Handshake,
  Heartbeat, ImageSquare, Infinity, Invoice,
  Joystick, Key, Keyboard, Lamp, Lightbulb as PhLightbulb,
  ListChecks, Lock, MagicWand, MapPin, MapPinLine,
  Martini, MathOperations, Medal, MegaphoneSimple, Microphone,
  Monitor, MoonStars, Motorcycle, NavigationArrow, Note,
  Notebook, Notepad, Package, PawPrint, Pen,
  PenNib, PenNibStraight, PencilCircle, PersonArmsSpread,
  PersonSimpleSnowboard, PersonSimpleThrow, PianoKeys, Pizza,
  Printer, Pulse, Racquet, Recycle, Rocket,
  Ruler, Sailboat, Scales, Seal, Shapes,
  ShieldPlus, ShoppingCart, Spiral, SpeakerHigh, StarFour,
  StarHalf, Suitcase, Swatches, Sword, Syringe,
  Television, TestTube, Thermometer, Toolbox, Train,
  Trash as PhTrash, TrendDown, TrendUp, UserCircle, UserPlus as PhUserPlus,
  UsersThree, Vault, VinylRecord, Virus, Waves,
  WashingMachine, Wind as PhWind2, Wrench,
  BellSimple,
} from '../PhosphorIcons';
import { Layers, Sprout, LayoutGrid, History, CalendarHeart, Timer, Sparkles, Pencil, Trash2, Archive, ArchiveRestore, Check, X, BarChart2, SkipForward, Undo2, Redo2, Milestone, Paintbrush, Wind, BookOpen, Zap, Headphones, Users, Coins, Apple, Laptop, Home, Trees, Dumbbell, Heart, Brain, RotateCcw, ClipboardList, Bell, CalendarCheck, CheckSquare, Plus, Minus, ChevronRight, ChevronLeft, ChevronUp, ChevronDown, Shield, ShieldCheck, ShieldOff, RefreshCw, Settings, Search, Save, Edit3, ListTodo, Star, FolderPlus, ArrowLeft, ArrowRight, MoreVertical, Share2, Copy, Pin, PinOff, LogOut, AlertTriangle, CheckCircle, XCircle, PlayCircle, PauseCircle, Maximize2, Minimize2, Filter, FileText, Calendar, Target, BookMarked, Link, ExternalLink, Upload, Info, Activity, Trophy, Flame, Palette, Type, CalendarDays, LayoutDashboard, HelpCircle, MessageCircle, UserPlus, Gift, Leaf, Music, Pill, Moon, Sunrise, GraduationCap, Microscope, Flower2, Cloud, Snowflake, Dog, Fish, Cat, Baby, Bike, Plane, Sandwich, Coffee, NotebookText, Lightbulb, CircleDot, Rainbow, ShoppingBag, DollarSign, Film, Mail, Mic, Navigation, PenLine, Phone, Car, Bus, Camera, Briefcase, Code, Scissors, Clock, Droplets, Footprints, HeartPulse, Sofa, TrendingUp, Utensils, Wand2, Highlighter, Image, Square, Folder, HeartCrack, Tag, GripVertical, Award, Banknote, BedDouble, Book, Bookmark, Box, Brush, Building2, CheckCircle2, ChefHat, Clipboard, Cog, Droplet, Feather, Flag, Flashlight, Gamepad2, Gauge, Glasses, Hammer, HeartHandshake, Mountain, Newspaper, Palmtree, PartyPopper, PenTool, PersonStanding, Puzzle, School, Shirt, ShowerHead, Smile, ThumbsUp, TreePine, Umbrella, Watch, Wine } from 'lucide-react';

// Colors are evenly spaced around the hue wheel (360°/14 ≈ 25.7° apart) at a
// consistent light pastel tone (HSL s=0.55, l=0.80) — every default category
// gets its own distinct hue instead of clustering near a few warm/cool tones,
// and none of them read as dark/vibrant the way the old picks did.
// The eight onboarding starter categories use Jade's own colours (2026-10-11):
// Self Care, Fitness, Chores, Productivity, Finance, Work, Creative & Projects
// and School. The rest keep the evenly spaced pastels described above.
export const DEFAULT_CATEGORIES = [
  { id: "cat-hygiene",   emoji: "⭐", phosphorIcon: "Star",           title: "Self Care",            color: "#fbcabb", isGoal: false, goalDescription: "" },
  { id: "cat-art",       emoji: "🎨", phosphorIcon: "Palette",        title: "Creative & Projects",  color: "#f9c9d6", isGoal: false, goalDescription: "" },
  { id: "cat-study",     emoji: "📖", phosphorIcon: "BookOpenText",   title: "Learning",             color: "#b0b8e8", isGoal: false, goalDescription: "" },
  { id: "cat-fitness",   emoji: "💪", phosphorIcon: "Barbell",        title: "Fitness",              color: "#c0e0f2", isGoal: false, goalDescription: "" },
  { id: "cat-entertain", emoji: "🎧", phosphorIcon: "Headphones",     title: "Entertainment",        color: "#c0e8b0", isGoal: false, goalDescription: "" },
  { id: "cat-social",    emoji: "🫂", phosphorIcon: "Users",          title: "Social",               color: "#d8e8b0", isGoal: false, goalDescription: "" },
  { id: "cat-finance",   emoji: "🪙", phosphorIcon: "Coins",          title: "Finance",              color: "#b0e8e8", isGoal: false, goalDescription: "" },
  { id: "cat-health",    emoji: "🍎", phosphorIcon: "AppleLogo",      title: "Wellness",             color: "#e8b0e0", isGoal: false, goalDescription: "" },
  { id: "cat-work",      emoji: "💻", phosphorIcon: "Laptop",         title: "Work",                 color: "#e2c4bb", isGoal: false, goalDescription: "" },
  { id: "cat-home",      emoji: "🧹", phosphorIcon: "Broom",          title: "Chores",               color: "#ffe6b3", isGoal: false, goalDescription: "" },
  { id: "cat-freetime",  emoji: "🍃", phosphorIcon: "Leaf",           title: "Free Time",            color: "#e8c8b0", isGoal: false, goalDescription: "" },
  { id: "cat-productivity", emoji: "🚀", phosphorIcon: "Rocket",      title: "Productivity",         color: "#d4c8f3", isGoal: false, goalDescription: "" },
  { id: "cat-errands",   emoji: "📋", phosphorIcon: "ClipboardText",  title: "Errands",              color: "#c0b0e8", isGoal: false, goalDescription: "" },
  { id: "cat-school",    emoji: "🎓", phosphorIcon: "GraduationCap",  title: "School",               color: "#c4e9bd", isGoal: false, goalDescription: "" },
];

export const PHOSPHOR_TO_LUCIDE = {
  Sparkle: "Sparkles", PaintBrush: "Paintbrush", Wind: "Wind",
  BookOpenText: "BookOpen", Barbell: "Dumbbell", Headphones: "Headphones",
  PhUsers: "Users", Coins: "Coins", Apple: "Apple", Laptop: "Laptop",
  House: "Home", Tree: "Trees", Brain: "Brain", PhHeart: "Heart",
  Leaf: "Leaf", NotePencil: "NotebookText", Lightning: "Zap",
  MusicNote: "Music", Basketball: "CircleDot", Coffee: "Coffee",
  Pill: "Pill", Moon: "Moon", SunHorizon: "Sunrise",
  GraduationCap: "GraduationCap", Microscope: "Microscope", PhStar: "Star",
  Flower: "Flower2", ShootingStar: "Star", Rainbow: "Rainbow",
  Cloud: "Cloud", Snowflake: "Snowflake", Dog: "Dog", Fish: "Fish",
  Cat: "Cat", Baby: "Baby", Bicycle: "Bike", Airplane: "Plane",
  Hamburger: "Sandwich",
};

export const LUCIDE_ICON_MAP = {
  Activity, Anchor, Apple, BarChart2, Baby, Bell, Bike, BookMarked, BookOpen,
  Brain, Briefcase, Bus, Calculator, CalendarHeart, Camera, Car, CircleDot,
  Cloud, Code, Coffee, Compass, Dumbbell, Dog, Cat,
  DollarSign, Eye, Film, Flame, Flower2,
  GraduationCap, Globe, Gift, Heart, Home, Laptop,
  Leaf, Lightbulb, Mail, MapPin, Medal, Mic, Microscope, Milestone,
  Moon, Music, Navigation, NotebookText, Package, Paintbrush, Palette,
  Pencil, PenLine, Phone, PiggyBank, Pill, Plane, Printer,
  Rainbow, Sandwich, Scissors, Search, Share2, ShoppingBag, Snowflake,
  Sparkles, Sprout, Star, Stethoscope, Sun, Target,
  Timer, Train, Trees, Trophy, Type, UserPlus,
  Users, Wallet, Wind, Zap,
  // legacy keys from existing saved category data
  Headphones, Coins, Fish, Sunrise,
  // extra icon options
  Award, Banknote, BedDouble, Book, Bookmark, Box, Brush, Building2,
  CheckCircle2, ChefHat, Clipboard, Cog, Droplet, Feather, Flag, Flashlight,
  Gamepad2, Gauge, Glasses, Hammer, HeartHandshake, Mountain, Newspaper,
  Palmtree, PartyPopper, PenTool, PersonStanding, Puzzle, School,
  Shirt, ShowerHead, Smile, ThumbsUp, TreePine, Umbrella, Watch, Wine,
};

export const CAT_ICON_OPTIONS = Object.entries(LUCIDE_ICON_MAP).map(([key, C]) => ({ key, C }));

export const PH_ICON_MAP = {
  Acorn, Airplane, AirplaneLanding, AirplaneTakeoff, Alarm, Anchor,
  Aperture, AppleLogo: PhApple, Armchair, ArrowsClockwise: PhArrowsClockwise,
  Atom, Avocado, Baby: PhBaby, Backpack, Balloon, Bandaids, Bank,
  Barbell, Baseball: TennisBall2, Basketball, Bathtub, Bed,
  BeerStein, BellSimple, Bicycle, Boat, Bone, BookBookmark, BookOpenText,
  BowlFood, BowlSteam, BoxingGlove, Brain: PhBrain, Bread, Briefcase: PhBriefcase,
  Broadcast, Broom, Bug, BugBeetle, Bus: PhBus, Butterfly, Cactus,
  Cake, Calculator, CalendarCheck: PhCalCheck, Camera: PhCamera, Car: PhCar,
  Cards, Carrot, CassetteTape, CastleTurret, Cat: PhCat, Certificate,
  ChalkboardTeacher, Champagne, ChartBar, ChartLine: PhChartLine, ChartPie,
  ChatCircle, ChatDots, ChatTeardrop, Chats, CheckCircle: PhCheckCircle,
  CirclesThree, ClipboardText, Cloud, CloudLightning, CloudMoon, CloudRain,
  CloudSnow, CloudSun, Code: PhCode, Coffee: PhCoffee, Coins: PhCoins,
  Compass, Confetti, Cookie, CookingPot, Couch, CreditCard, Crosshair,
  Crown, CurrencyDollar, Desktop, Diamond, DiceFive, Dna, Dog: PhDog,
  Door, Drop, Egg, Envelope: PhEnvelope, Eraser, Exam, Eye, EyeSlash,
  FilmStrip, FireSimple, FirstAidKit, Fish: PhFish, FishSimple, Flag: PhFlag,
  Flask, FlowArrow, Flower, Football, ForkKnife, FrameCorners,
  GameController, Gavel, Gift: PhGift, Globe, GraduationCap: PhGrad,
  Grains, GrainsSlash, Guitar, Hamburger, Hammer: PhHammer, HandSoap,
  HandsPraying, Handshake, Headphones: PhHeadphones, Heart: PhHeart,
  HeartStraight, Heartbeat, House, HourglassHigh, IceCream, ImageSquare,
  Infinity, Invoice, Island, Joystick, Key, Keyboard, Lamp, Laptop: PhLaptop,
  Leaf: PhLeaf, Lightbulb: PhLightbulb, Lightning, ListChecks, Lock, MagicWand,
  MapPin, MapPinLine, Martini, MathOperations, Medal, MegaphoneSimple,
  Microphone, Microscope: PhMicroscope, Monitor, Moon: PhMoon, MoonStars,
  Motorcycle, Mountains, MusicNote, NavigationArrow, Note, NotePencil,
  Notebook, Notepad, Orange, Package, PaintBrush, Palette: PhPalette2,
  PawPrint, Peace, Pen, PenNib, PenNibStraight, PencilCircle, PencilLine,
  PersonArmsSpread, PersonSimpleBike, PersonSimpleHike, PersonSimpleRun,
  PersonSimpleSki, PersonSimpleSnowboard, PersonSimpleSwim, PersonSimpleTaiChi,
  PersonSimpleThrow, PersonSimpleWalk, Phone: PhPhone, PianoKeys, PiggyBank,
  Pill: PhPill, Pizza, Plant, Printer, Pulse, Racquet, Rainbow: Sparkle,
  Recycle, Robot: PhRobot, Rocket, Ruler, Sailboat, Scales, Scissors: PhScissors,
  Seal, Shapes, ShieldPlus, ShootingStar, ShoppingCart, Shower, Smiley,
  SmileyAngry, SmileyMeh, SmileyNervous, SmileySad, SmileyWink, SneakerMove,
  Snowflake: PhSnowflake, SoccerBall, Sparkle, SpeakerHigh, Spiral,
  Star: PhStar, StarFour, StarHalf, Stethoscope, Suitcase, Sun, SunHorizon,
  Swatches, SwimmingPool, Sword, Syringe, Target: Sparkle, Television,
  TennisBall: TennisBall2, Tent, Terminal: PhTerminal, TestTube, Thermometer,
  Timer: PhTimer, ToiletPaper, Toolbox, Tooth, Train, Trash: PhTrash, TrendDown,
  TrendUp, Trophy: PhTrophy, UserCircle, UserPlus, Users: PhUsers, UsersThree,
  Vault, VideoCamera, VinylRecord, Virus, Volleyball, Wallet, WashingMachine,
  Waves, Wind: PhWind, Wine: PhWine, Wrench, YinYang,
};

export const HABIT_ICON_OPTIONS = Object.entries(PH_ICON_MAP).map(([key, C]) => ({ key, C }));

export const PHOSPHOR_ICON_CATEGORIES = [
  { id: "fitness", icon: "🏃", label: "Fitness",
    icons: ["Barbell","PersonSimpleRun","Bicycle","PersonSimpleBike","PersonSimpleSwim","PersonSimpleHike","PersonSimpleSki","PersonSimpleWalk","PersonSimpleTaiChi","PersonSimpleThrow","PersonSimpleSnowboard","SoccerBall","Football","TennisBall","Volleyball","Basketball","SneakerMove","SwimmingPool","Racquet","BoxingGlove","PersonArmsSpread","Baseball","Sword"] },
  { id: "health", icon: "❤️", label: "Health",
    icons: ["HeartStraight","FirstAidKit","Stethoscope","Pill","Drop","Eye","EyeSlash","Tooth","Bed","Shower","Bathtub","Syringe","Thermometer","Bandaids","HandSoap","Virus","Bone","Heartbeat","Pulse","ShieldPlus","Dna","Microscope","TestTube","Flask"] },
  { id: "food", icon: "🍽️", label: "Food",
    icons: ["BowlFood","ForkKnife","CookingPot","AppleLogo","Orange","Carrot","Bread","Coffee","IceCream","Cookie","BeerStein","Wine","Hamburger","Pizza","Egg","FishSimple","Martini","BowlSteam","Avocado","Grains","GrainsSlash","Fish"] },
  { id: "mind", icon: "🧠", label: "Mind",
    icons: ["Brain","BookOpenText","BookBookmark","GraduationCap","PencilLine","NotePencil","Backpack","Code","Terminal","Robot","Lightbulb","ChalkboardTeacher","Certificate","Exam","FlowArrow","MathOperations","Atom","Compass","Globe","Notepad","Notebook","Note","Keyboard","Desktop","Laptop","Monitor","Eraser","Ruler","Seal","Calculator"] },
  { id: "creative", icon: "🎨", label: "Creative",
    icons: ["Palette","PaintBrush","MusicNote","Guitar","Camera","VideoCamera","FilmStrip","GameController","Scissors","PencilCircle","PenNib","PenNibStraight","Pen","PianoKeys","Microphone","Headphones","SpeakerHigh","FrameCorners","ImageSquare","Aperture","Swatches","Shapes"] },
  { id: "wellness", icon: "🌙", label: "Wellness",
    icons: ["Sparkle","HandsPraying","Peace","YinYang","Smiley","SmileyWink","SmileyMeh","SmileySad","SmileyNervous","SmileyAngry","MoonStars","Infinity","Spiral","CirclesThree","CloudMoon","Wind","Waves","MagicWand"] },
  { id: "nature", icon: "🌿", label: "Nature",
    icons: ["Sun","SunHorizon","CloudSun","Moon","Snowflake","Flower","Leaf","Plant","Tree","TreeEvergreen","Mountains","Island","Tent","Cloud","CloudRain","CloudSnow","CloudLightning","Boat","Anchor","Butterfly","Bug","BugBeetle","PawPrint","Cactus","Acorn","Sailboat"] },
  { id: "home", icon: "🏠", label: "Home",
    icons: ["House","Broom","Hammer","ToiletPaper","Dog","Cat","Baby","Armchair","Couch","Door","Key","Lock","Wrench","Toolbox","Lamp","Television","WashingMachine","ShoppingCart","Package","Trash","Recycle"] },
  { id: "productivity", icon: "🎯", label: "Goals",
    icons: ["Flag","Trophy","CheckCircle","Timer","HourglassHigh","Alarm","CalendarCheck","Lightning","FireSimple","Fire","ArrowsClockwise","Crosshair","ChartLine","ChartBar","ChartPie","TrendUp","TrendDown","ListChecks","ClipboardText","Star","StarHalf","StarFour","Medal","Rocket","ShootingStar"] },
  { id: "social", icon: "👥", label: "Social",
    icons: ["Users","Heart","ChatTeardrop","Phone","Envelope","Handshake","ChatCircle","ChatDots","Chats","UserPlus","UsersThree","UserCircle","BellSimple","MegaphoneSimple","Broadcast","Gift"] },
  { id: "finance", icon: "💼", label: "Finance",
    icons: ["Coins","Wallet","PiggyBank","CurrencyDollar","Vault","Bank","CreditCard","Invoice","Gavel","Scales","Briefcase","Printer"] },
  { id: "travel", icon: "✈️", label: "Travel",
    icons: ["Airplane","Car","Bus","Train","Motorcycle","AirplaneTakeoff","AirplaneLanding","MapPin","MapPinLine","NavigationArrow","Suitcase"] },
  { id: "fun", icon: "🎉", label: "Fun",
    icons: ["Confetti","Crown","Diamond","Balloon","Cake","Champagne","DiceFive","Cards","CastleTurret","Joystick","VinylRecord","CassetteTape"] },
];

export const LUCIDE_ICON_CATEGORIES = [
  { id: "fitness",  icon: "🏃", label: "Fitness",
    icons: ["Dumbbell","Bike","Activity","Zap","Flame","Target","Trophy","Medal","Timer","Footprints"] },
  { id: "health",   icon: "❤️", label: "Health",
    icons: ["Heart","Stethoscope","Pill","Apple","Eye","Moon","Sun","Leaf","Droplets","HeartPulse"] },
  { id: "mind",     icon: "🧠", label: "Mind",
    icons: ["Brain","BookOpen","GraduationCap","Lightbulb","Microscope","Pencil","NotebookText","Search","Code","BookMarked"] },
  { id: "creative", icon: "🎨", label: "Creative",
    icons: ["Palette","Paintbrush","Music","Camera","Film","Mic","PenLine","Scissors","Wand2","Type"] },
  { id: "nature",   icon: "🌿", label: "Nature",
    icons: ["Leaf","Sprout","Trees","Flower2","Cloud","Snowflake","Sun","Moon","Rainbow","Wind"] },
  { id: "home",     icon: "🏠", label: "Home",
    icons: ["Home","Dog","Cat","Baby","Coffee","ShoppingBag","Package","Sandwich","Utensils","Sofa"] },
  { id: "work",     icon: "💼", label: "Work",
    icons: ["Briefcase","Laptop","Target","BarChart2","TrendingUp","DollarSign","PiggyBank","Wallet","Calculator","Printer"] },
  { id: "social",   icon: "👥", label: "Social",
    icons: ["Users","MessageCircle","Phone","Mail","Heart","Gift","Bell","Star","UserPlus","Share2"] },
  { id: "travel",   icon: "✈️", label: "Travel",
    icons: ["Plane","Car","Bus","Train","Bike","Anchor","Compass","MapPin","Globe","Navigation"] },
  { id: "misc",     icon: "✨", label: "Misc",
    icons: ["Star","Sparkles","Zap","Flame","Rainbow","CircleDot","Milestone","CalendarHeart","Clock","Trophy"] },
];
